
var dateServiceSolic = new Date();
var diaServiceSolic = dateServiceSolic.getDate();
var mesServiceSolic = dateServiceSolic.getMonth();
var anoServiceSolic = dateServiceSolic.getFullYear();
$(function() {
    $('.solicitarService').click(function () {
        $('#modalServiceSolic').modal('open');
        $('#dateServiceSolic').click();
        $('#hourServiceSolic').click();
        $('#modalServiceSolic #serviceSolic').val(this.name);
        $('#modalServiceSolic #idServiceSolic').val(this.id);

    });

    $('.datepickerServiceSolic').datepicker({
        selectMonths: true, // Creates a dropdown to control month
        yearRange: 0, // Creates a dropdown of 15 years to control year,
        format: 'yyyy/mm/dd',
        minDate: new Date(anoServiceSolic, mesServiceSolic, diaServiceSolic),
        maxDate: new Date(anoServiceSolic, mesServiceSolic + 1, diaServiceSolic),
        autoClose: true,
        disableWeekends: true,
        onSelect: function () {
            //$(this).data('datepicker').inline = true;
        },
        onClose: function () {
            $(this).data('datepicker').inline = false;
        },
        closeOnSelect: false,
        showClearBtn: false,
        i18n: {
            clear: 'Limpiar',
            cancel: 'Cancelar',
            done: 'Seleccionar',
            labelMonthNext: 'Próximo Mes',
            labelMonthPrev: 'Mes Anterior',
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            weekdaysLetter: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        },
    });

    $('.timepickerServiceSolic').timepicker({
        autoClose: true,
        twelveHour: false,
        vibrate: true,
    });

    $('#dateServiceSolic').change(function () {
        //alert('cambio');
        setTimeout(function () {
            $('#dateServiceSolic').click();
            dispoDateServiceSolic();
            getHourServiceSolic();
        }, 100);
    });

    $('#hourServiceSolic').change(function () {
        setTimeout(function () {
            $('#hourServiceSolic').click();
            dispoTimeServiceSolic();
        }, 0);
    });

    $('#modalServiceSolic .boton_two .btn').click(function () {
        $('#dateServiceSolic').click();
        $('#dateServiceSolic').val();
    });

    function dispoDateServiceSolic() {
        var dateServiceSolic = $('#dateServiceSolic').val();
        $.ajax({
            url: https + "dispoDateServiceSolic",
            method: "POST",
            data: {date: dateServiceSolic, action: 'dispoDateServiceSolic'},
            success: function (data) {
                if ($.trim(data) == "1") {
                    $('#dispoServiceSolic').css('background', '#39d81c', 'important');
                    $('#dispoServiceSolic').val('HAY CUPO');
                    $('#dispoServiceSolic').css('color', '#ffffff', 'important');
                } else if ($.trim(data) == "2") {
                    $('#dispoServiceSolic').css('background', '#ced0d3', 'important');
                    $('#dispoServiceSolic').val('No disponibilidad en la fecha');
                } else if ($.trim(data) == "3") {
                    $('#dispoServiceSolic').css('background', '#d30826', 'important');
                    $('#dispoServiceSolic').css('color', '#ffffff', 'important');
                    $('#dispoServiceSolic').val('CUPO LLENO');
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    }

    function getHourServiceSolic() {
        var getHourServiceSolic = $('#dateServiceSolic').val();
        var idElement = 'hourServiceSolic';
        $('#' + idElement + ' .opctions' + idElement).remove();
        $.ajax({
            url: https + "getHourServiceSolic",
            type: "POST",
            dataType: "json",
            data: {date: getHourServiceSolic, action: 'getHourServiceSolic'},
            success: function (datos) {
                $.each(datos, function (index, d) {
                    $('#' + idElement).append('<option class="opctions' + idElement + '" value="' + d.id + '">' + d.name + '</option> ');
                });
            }
        });
    }

    $('.submitmModalServiceSolicForm').click(function () {
        $('#modalServiceSolicForm').submit();
    });

    $('#modalServiceSolicForm').on('submit', function (e) {
        e.preventDefault();

        elementsForm = [
            "idServiceSolic",
            "serviceSolic",
            "dateServiceSolic",
            "hourServiceSolic",
        ];

        contLogin = validationForm(elementsForm, contLogin = 1);

        if (contLogin == 0) {
            swal({
                text: "Debes completar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        var data = $(this).serialize();

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });

        $.ajax({
            url: https + "serviceSolic",
            method: "POST",
            data: data,
            success: function (data) {
                swal.close();
                if ($.trim(data) == "1") {
                    swal({
                        text: "Agendado, Gracias por escogernos",
                        icon: imageURL,
                        button: false,
                    });
                    $('#dispoServiceSolic').css('background', '#39d81c', 'important');
                    $('#dispoServiceSolic').val('AGENDANDO');
                    $('#dispoServiceSolic').css('color', '#ffffff', 'important');
                    setTimeout(function () {
                        location.reload();
                    }, 2000);
                } else if ($.trim(data) == "2") {
                    $('#dispoServiceSolic').css('background', '#ced0d3', 'important');
                    $('#dispoServiceSolic').val('No disponibilidad en la fecha');
                } else if ($.trim(data) == "3") {
                    $('#dispoServiceSolic').css('background', '#d30826', 'important');
                    $('#dispoServiceSolic').css('color', '#ffffff', 'important');
                    $('#dispoServiceSolic').val('CUPO LLENO EN ESTA HORA');
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });

    });


    function validationForm(elementsForm, contLogin) {
        for (var i = 0; i < elementsForm.length; i++) {

            $('#' + elementsForm[i]).removeClass('error');

            if ($.trim($("#" + elementsForm[i]).val()) == "") {
                contLogin = 0;
                $('#' + elementsForm[i]).addClass('error');
            }

        }

        return contLogin;
    }
    $('.listPedidos .modalAccountInfo').click(function () {
       $('#modalAccountInfo').modal('open');
    });
});